import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dashboardActions from "../redux/dashboard/actions";
import CardLayout from "../components/utils/CardLayout";
import {
  isAdmin,
  isDealer,
  isAdminAgent,
  isDealerAgent,
  formatDigits,
} from "../helpers/commonFunction";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const { getDashboardData, getChartData } = dashboardActions;

function Dashboard() {
  const { tokenData, loading: getUserByTokenLoading } = useSelector(
    (state) => state.auth,
  );
  // const dateFormat = process.env.REACT_APP_DATE_FORMAT;
  // const timeFormat = process.env.REACT_APP_TIME_FORMAT;
  const dispatch = useDispatch();
  const {
    dashboardData,
    dashboardLoading,
    chartData,
    dashboardMessage,
    dashboardError,
  } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(getDashboardData());
    dispatch(getChartData());
  }, [dispatch]);

  const responseData = chartData?.DailyChartData ?? [];

  const chartsData = {
    labels: [
      ...new Set(
        responseData.map((item) =>
          new Date(item.DateDay).toLocaleDateString("en-US", {
            timeZone: "UTC",
          }),
        ),
      ),
    ],

    datasets: [
      {
        label: "Chatr Activation",
        data: responseData
          .filter((item) => item.Type === "ChatrActivation")
          .map((item) => item.Processed ?? 0),
        borderColor: "#007bff",
        backgroundColor: "rgba(0, 123, 255, 0.1)",
        tension: 0.4,
      },

      {
        label: "Chatr Recharge",
        data: responseData
          .filter((item) => item.Type === "ChatrRecharge")
          .map((item) => item.Processed ?? 0),
        borderColor: "#28a745",
        backgroundColor: "rgba(40, 167, 69, 0.1)",
        tension: 0.4,
      },

      {
        label: "MDN Swap",
        data: responseData
          .filter((item) => item.Type === "MDNSwap")
          .map((item) => item.Processed ?? 0),
        borderColor: "#dc3545",
        backgroundColor: "rgba(220, 53, 69, 0.1)",
        tension: 0.4,
      },
    ],
  };

  const chartOptions = {
    responsive: true,

    plugins: {
      legend: {
        position: "top",
      },

      title: {
        display: true,
        text: "Chatr Activation, Recharge & MDN Swap",
      },
    },

    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          precision: 0,
        },
      },
    },
  };

  const pinPrice10 = dashboardData?.SIMPINInventory?.find(
    (item) => item.PINPrice === 10,
  );
  const pinPrice25 = dashboardData?.SIMPINInventory?.find(
    (item) => item.PINPrice === 25,
  );

  return (
    <>
      {!getUserByTokenLoading && (
        <CardLayout>
          <div className="container-fluid ">
            {/* ================= SIM PIN INVENTORY ================= */}
            <div className="row">
              {/* ================= $10 CARD ================= */}
              {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
                <div className="col-sm-12 col-md-6">
                  <div className="iq-card iq-card-block iq-card-stretch iq-card-height  bg-light ">
                    <div className="iq-card-body">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="card-title mb-0">
                          SIM PIN Inventory $10.00
                        </h4>

                        <i
                          className="ri-refresh-line"
                          onClick={() => dispatch(getDashboardData())}
                          style={{
                            fontSize: "1.2rem",
                            cursor: "pointer",
                          }}
                        ></i>
                      </div>

                      {dashboardLoading ? (
                        <div className="dashboard-activation-loader-month">
                          <span className="spinner-border" role="status"></span>
                        </div>
                      ) : (
                        <div className="row text-center ">
                          <div className="col-4">
                            <h5>Total</h5>

                            <div className="badge badge-textStyle badge-pill">
                              {pinPrice10?.TotalPINInventory ?? 0}
                            </div>
                          </div>

                          {/* Used */}
                          <div className="col-4">
                            <h5>Used</h5>

                            <div className="badge badge-textStyle badge-pill ">
                              {pinPrice10?.UsedPINInventory ?? 0}
                            </div>
                          </div>

                          <div className="col-4">
                            <h5>Free</h5>

                            <div className="badge badge-textStyle badge-pill ">
                              {pinPrice10?.FreePINInventory ?? 0}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* ================= $25 CARD ================= */}
              {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
                <div className="col-sm-12 col-md-6">
                  <div className="iq-card iq-card-block iq-card-stretch iq-card-height  bg-light">
                    <div className="iq-card-body">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="card-title mb-0">
                          SIM PIN Inventory $25.00
                        </h4>

                        <i
                          className="ri-refresh-line"
                          onClick={() => dispatch(getDashboardData())}
                          style={{
                            fontSize: "1.2rem",
                            cursor: "pointer",
                          }}
                        ></i>
                      </div>
                      {dashboardLoading ? (
                        <div className="dashboard-activation-loader-month">
                          <span className="spinner-border" role="status"></span>
                        </div>
                      ) : (
                        <div className="row text-center">
                          <div className="col-4">
                            <h5>Total</h5>

                            <div className="badge badge-textStyle badge-pill ">
                              {pinPrice25?.TotalPINInventory ?? 0}
                            </div>
                          </div>

                          {/* Used */}
                          <div className="col-4">
                            <h5>Used</h5>

                            <div className="badge badge-textStyle badge-pill ">
                              {pinPrice25?.UsedPINInventory ?? 0}
                            </div>
                          </div>

                          {/* Free - Admin Only */}

                          <div className="col-4">
                            <h5>Free</h5>

                            <div className="badge badge-textStyle badge-pill ">
                              {pinPrice25?.FreePINInventory ?? 0}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* ACTIVATION / RECHARGE / MDN SWAP ROW */}
            <div className="row mt-1">
              {/* ================= CHATR ACTIVATION ================= */}
              <div className="col-sm-12 col-md-6 col-lg-4">
                <div className="iq-card iq-card-block iq-card-stretch iq-card-height bg-light">
                  <div className="iq-card-header d-flex justify-content-between">
                    <div className="iq-header-title">
                      <h4 className="card-title">Chatr Activation</h4>
                    </div>

                    <div>
                      <i
                        className="ri-refresh-line"
                        onClick={() => dispatch(getDashboardData())}
                        style={{
                          fontSize: "1.2rem",
                          cursor: "pointer",
                        }}
                      ></i>
                    </div>
                  </div>

                  {dashboardLoading ? (
                    <div className="dashboard-activation-loader-month">
                      <span className="spinner-border" role="status"></span>
                    </div>
                  ) : (
                    <div className="iq-card-body">
                      <div className="row text-center">
                        {/* Processed */}
                        <div className="col-6">
                          <h5>Processed</h5>

                          <div className="badge badge-textStyle badge-pill ">
                            {dashboardData?.ChatrActivation?.[0]?.Processed ??
                              0}
                          </div>
                        </div>

                        {/* Total Price */}
                        <div className="col-6">
                          <h5>Total Price</h5>

                          <div className="badge badge-textStyle badge-pill ">
                            {"$" +
                              Number(
                                dashboardData?.ChatrActivation?.[0]
                                  ?.TotalPrice ?? "$0.00",
                              ).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* ================= CHATR RECHARGE ================= */}
              <div className="col-sm-12 col-md-6 col-lg-4">
                <div className="iq-card iq-card-block iq-card-stretch iq-card-height bg-light">
                  <div className="iq-card-header d-flex justify-content-between">
                    <div className="iq-header-title">
                      <h4 className="card-title">Chatr Recharge</h4>
                    </div>

                    <div>
                      <i
                        className="ri-refresh-line"
                        onClick={() => dispatch(getDashboardData())}
                        style={{
                          fontSize: "1.2rem",
                          cursor: "pointer",
                        }}
                      ></i>
                    </div>
                  </div>

                  {dashboardLoading ? (
                    <div className="dashboard-activation-loader-last-month">
                      <span className="spinner-border" role="status"></span>
                    </div>
                  ) : (
                    <div className="iq-card-body">
                      <div className="row text-center">
                        {/* Processed */}
                        <div className="col-6">
                          <h5>Processed</h5>

                          <div className="badge badge-textStyle badge-pill ">
                            {dashboardData?.ChatrRecharge?.[0]?.Processed ?? 0}
                          </div>
                        </div>

                        {/* Total Price */}
                        <div className="col-6">
                          <h5>Total Price</h5>

                          <div className="badge badge-textStyle badge-pill ">
                            {"$" +
                              Number(
                                dashboardData?.ChatrRecharge?.[0]?.TotalPrice ??
                                  "$0.00",
                              ).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* ================= MDN SWAP ================= */}
              <div className="col-sm-12 col-md-6 col-lg-4">
                <div className="iq-card iq-card-block iq-card-stretch iq-card-height  bg-light">
                  <div className="iq-card-header d-flex justify-content-between">
                    <div className="iq-header-title">
                      <h4 className="card-title">MDN Swap</h4>
                    </div>

                    <div>
                      <i
                        className="ri-refresh-line"
                        onClick={() => dispatch(getDashboardData())}
                        style={{
                          fontSize: "1.2rem",
                          cursor: "pointer",
                        }}
                      ></i>
                    </div>
                  </div>

                  {dashboardLoading ? (
                    <div className="dashboard-activation-loader-last-month">
                      <span className="spinner-border" role="status"></span>
                    </div>
                  ) : (
                    <div className="iq-card-body">
                      <div className="row text-center">
                        {/* Processed */}
                        <div className="col-6">
                          <h5>Processed</h5>

                          <div className="badge badge-textStyle badge-pill ">
                            {dashboardData?.MDNSwap?.[0]?.Processed ?? "0"}
                          </div>
                        </div>

                        {/* Total Price */}
                        <div className="col-6">
                          <h5>Total Price</h5>

                          <div className="badge badge-textStyle badge-pill ">
                            {"$" +
                              Number(
                                dashboardData?.MDNSwap?.[0]?.TotalPrice ??
                                  "$0.00",
                              ).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* LINE CHART */}
            <div className="row mt-0l justify-content-center">
              <div className="col-sm-12 col-md-10 col-lg-12 ">
                <div className="iq-card  bg-light">
                  {/* Chart Header */}
                  <div className="iq-card-header">
                    <div className="iq-header-title">
                      <h4 className="card-title">
                        Chatr Activation, Chatr Recharge & MDN Swap
                      </h4>
                    </div>
                  </div>

                  {/* Chart Body */}
                  <div
                    className="iq-card-body"
                    style={{
                      height: "400px",
                    }}
                  >
                    <Line options={chartOptions} data={chartsData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardLayout>
      )}
    </>
  );
}

export default Dashboard;
